import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SEO_CONFIG } from '@/config/seo';

/**
 * WebSite schema for the homepage.
 * Enables the Google Sitelinks Search Box for branded queries
 * and signals the site's search endpoint to crawlers.
 * Render alongside OrganizationJsonLd on the Index page only.
 */
export function WebsiteJsonLd() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SEO_CONFIG.siteName,
    url: SEO_CONFIG.baseUrl,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${SEO_CONFIG.baseUrl}/search?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}
